export default "__VITE_ASSET__CZjxDllx__"